<template>
    <div class="rma-drop" :class="{ 'rma-drop--over': over && !disabled, 'rma-drop--disabled': disabled }"
        @click="pick" @dragenter.prevent="onEnter" @dragover.prevent="onOver" @dragleave.prevent="onLeave" @drop.prevent="onDrop">
        <v-icon size="24" class="rma-drop__icon">{{ disabled ? "mdi-lock-outline" : "mdi-tray-arrow-up" }}</v-icon>
        <div class="rma-drop__text">
            <div class="rma-drop__title">{{ titleText }}</div>
            <div v-if="hint" class="rma-drop__hint">{{ hint }}</div>
        </div>
        <v-btn small outlined :disabled="disabled" class="rma-drop__button" @click.stop="pick">
            <v-icon left small>mdi-paperclip</v-icon>Selecionar arquivos
        </v-btn>
        <input ref="input" type="file" class="d-none" :accept="accept" :multiple="multiple" :disabled="disabled" @click.stop @change="onInput" />
    </div>
</template>

<script>
// Area de arrastar e soltar para varios arquivos (o UiFileDrop do backoffice so
// aceita um). So entrega os arquivos: evento `files` com um array de File; a
// validacao e o envio ficam com quem usa.
export default {
    name: "RmaFileDrop",

    props: {
        accept: { type: String, default: "" },
        disabled: { type: Boolean, default: false },
        hint: { type: String, default: "" },
        multiple: { type: Boolean, default: true },
        disabledText: { type: String, default: "Envio indisponível" },
    },

    data: () => ({ over: false, depth: 0 }),

    computed: {
        titleText() {
            if (this.disabled) return this.disabledText;
            if (this.over) return "Solte os arquivos para enviar";
            return this.multiple ? "Arraste os arquivos para cá ou clique para escolher" : "Arraste o arquivo para cá ou clique para escolher";
        },
    },

    methods: {
        pick() {
            if (this.disabled) return;
            this.$refs.input.click();
        },

        onEnter() {
            this.depth += 1;
            this.over = true;
        },

        onOver(event) {
            if (event.dataTransfer) event.dataTransfer.dropEffect = this.disabled ? "none" : "copy";
            this.over = true;
        },

        onLeave() {
            this.depth = Math.max(0, this.depth - 1);
            if (!this.depth) this.over = false;
        },

        onDrop(event) {
            this.depth = 0;
            this.over = false;
            if (this.disabled) return;
            this.emitFiles(event.dataTransfer && event.dataTransfer.files);
        },

        onInput(event) {
            const files = event.target.files;
            this.emitFiles(files);
            event.target.value = "";
        },

        emitFiles(list) {
            const files = Array.from(list || []);
            if (!files.length) return;
            this.$emit("files", this.multiple ? files : files.slice(0, 1));
        },
    },
};
</script>

<style lang="scss" scoped>
.rma-drop {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border: 1.5px dashed #cbd5e1;
    border-radius: 10px;
    background: #f8fafc;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;

    &:hover {
        border-color: #94a3b8;
    }
}

.rma-drop--over {
    border-color: #27306b;
    background: #f3f5fb;
}

.rma-drop--disabled {
    cursor: default;
    opacity: 0.75;

    &:hover {
        border-color: #cbd5e1;
    }
}

.rma-drop__icon {
    color: #64748b !important;
    flex-shrink: 0;
}

.rma-drop--over .rma-drop__icon {
    color: #27306b !important;
}

.rma-drop__text {
    flex: 1;
    min-width: 0;
}

.rma-drop__title {
    font-size: 14px;
    font-weight: 500;
    color: #0f172a;
    line-height: 1.35;
}

.rma-drop__hint {
    font-size: 12.5px;
    color: #64748b;
    margin-top: 2px;
    line-height: 1.4;
}

.rma-drop__button {
    flex-shrink: 0;
}

@media (max-width: 700px) {
    .rma-drop {
        flex-wrap: wrap;
    }

    .rma-drop__button {
        width: 100%;
    }
}
</style>
